import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import type { State, ColumnName } from '../../../../common/types';
import { setFieldIncluded } from '../../../../common/utils';

export type SetIsIncludedForColumnAction = (
	columnName: ColumnName,
	isIncludeInImport: boolean,
) => Action<State, void, void>;

export const setIsIncludedForColumn =
	(columnName: ColumnName, isIncludeInImport: boolean) =>
	({ setState, getState }: StoreActionApi<State>) => {
		const state = getState();

		if (state.mappingState === null) {
			return;
		}

		const updatedMappingState = setFieldIncluded(state.mappingState, columnName, isIncludeInImport);

		setState({
			mappingState: updatedMappingState,
		});
	};
